<template>
    <div id="quote-element" :class="{empty: !moduleData}">
        <div class="module outwards" v-if="moduleData && moduleData.Quotes.length" :class="moduleData.Background + ' ' + moduleData.Spacing" :id="moduleData.AnchorID">
            <p class="heading" v-if="moduleData.Title && moduleData.ShowTitle">{{moduleData.Title}}</p>
            <p class="heading" v-else>&nbsp;</p>
            <vue-glide :perView="1" :autoplay="5000" type="carousel" :gap="0">
                <vue-glide-slide v-for="(quote, index) in moduleData.Quotes" :key="index" :class="quote.Testimonial ? 'testimonial' : ''">
                    <div class="slide-body container">
                        <h3 v-html="quote.Title"></h3>
                        <p v-if="quote.Testimonial" v-html="quote.Testimonial"></p>
                        <p class="author">{{quote.Author}}</p>
                    </div>
                </vue-glide-slide>
                <template slot="control" v-if="moduleData.Quotes.length > 1">
                    <button data-glide-dir="<"><i class="fal fa-long-arrow-left"></i></button>
                    <button data-glide-dir=">"><i class="fal fa-long-arrow-right"></i></button>
                </template>
            </vue-glide>
            <div class="footer">
                <i v-if="moduleData.TripAdvisorLink" class="fab fa-tripadvisor"></i>
                <a v-if="moduleData.TripAdvisorLink" :href="moduleData.TripAdvisorLink" target="_blank">Check us out on TripAdvisor</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {Glide, GlideSlide} from 'vue-glide-js'

    export default {
        name: "QuoteElement",
        components: {
            [Glide.name]: Glide,
            [GlideSlide.name]: GlideSlide
        },
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        }
    }
</script>
